import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import Dashboard from './pages/Dashboard';
import LandingPage from './pages/LandingPage';

function App() {
  // Modern dark theme with cleaner colors
  const theme = createTheme({
    palette: {
      mode: 'dark',
      primary: { main: '#2196f3' }, // Modern blue
      secondary: { main: '#7e57c2' }, // Modern purple
      background: {
        default: '#121212', // Modern dark background
        paper: '#1e1e1e',   // Slightly lighter dark
      },
      text: {
        primary: '#ffffff',
        secondary: '#b0b0b0',
      },
      error: { main: '#f44336' },
      success: { main: '#4caf50' },
      warning: { main: '#ff9800' },
      info: { main: '#03a9f4' },
      bmwAccent: {
        lightBlue: '#42a5f5',
        midBlue: '#2196f3',
        darkBlue: '#1976d2',
        red: '#f44336'
      }
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      button: { textTransform: 'none' }
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
            overflow: 'hidden',
            borderRadius: 8, // more modern rounded corners
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)' // subtle, modern shadow
          }
        }
      },
      MuiBox: {
        styleOverrides: {
          root: {
            boxSizing: 'border-box'
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8, // Rounded buttons
            fontWeight: 500
          }
        }
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
          }
        }
      }
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          {/* Landing page needs to be scrollable */}
          <Route path="/" element={
            <Box sx={{ 
              display: 'flex',
              flexDirection: 'column',
              minHeight: '100vh',
              width: '100%'
              // No overflow:hidden here to allow scrolling
            }}>
              <LandingPage />
            </Box>
          } />
          
          {/* Dashboard needs fixed height and overflow hidden */}
          <Route path="/dashboard" element={
            <Box sx={{ 
              display: 'flex',
              flexDirection: 'column',
              height: '100vh',
              width: '100vw',
              overflow: 'hidden'
            }}>
              <Dashboard />
            </Box>
          } />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
